import Section from '../components/Section';
import { DataContainer } from '../components/DataContainer';
import BrandFilter from '../components/BrandFilter';

import FNS from '../api';
import UnreadFeedbackTable from '../tables/UnreadFeedbackTable';
import FeedbacklessJobs from '../tables/FeedbacklessJobs';




function Feedback() {
    return (
        <div className="column g32 p32">
            <div className="row g16 center-cross">
                <BrandFilter />
            </div>

            <Section title="Uus tagasiside tehtud töödelt">
                <DataContainer actionType={'shownData/fetch/unreadFeedback'}>
                    <UnreadFeedbackTable />
                </DataContainer>
            </Section>

            <Section title="Tagasisideta tööd">
                <DataContainer actionType={'shownData/fetch/feedbacklessJobs'}>
                    <FeedbacklessJobs />
                </DataContainer>
            </Section>
        </div>
    );
}

export default Feedback;